export const FEATURE_KEYS = [
  "events.modals.checkpointAccess.features.multipleCheckpoints",
  "events.modals.checkpointAccess.features.teamAccess",
  "events.modals.checkpointAccess.features.realTimeSync",
  "events.modals.checkpointAccess.features.scanHistory",
];
